module.exports = __webpack_public_path__ + "Private_class@2x.f7081682.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/pages/ClassOne/images/Private_class@2x.png
// module id = 9sfX
// module chunks = 0